export default {
  2: {
    text: "Wo haben Sie die Beschwerden?",
    textAlt: "Wo genau haben Sie die Beschwerden?",
    type: "painarea",
    info: {
      image: {
        all: "headselect.png",
        zahn: "pain_bot_loop.gif",
      },
      text: {
        all: "Klicken Sie auf die Körperstelle, wo Sie die Beschwerden spüren. Für die Körperrückseite klicken Sie einfach auf „Drehen“.",
        zahn: "Klicken Sie auf die Stelle, wo Sie die Beschwerden spüren.",
      },
    },
    infoAlt: {
      image: "pain_bot_loop.gif",
      text: {
        all: "Klicken Sie auf die konkrete Körperstelle, wo Sie die Beschwerden am stärksten spüren.",
        zahn: "Klicken Sie auf die Stelle, wo Sie die Beschwerden spüren.",
      },
    },
  },
  4: {
    text: "Haben Sie eher mentale oder körperliche Beschwerden?",
    type: "buttons",
    options: [
      {
        value: "körperlich",
      },
      {
        value: "mental",
      },
      {
        value: "beides",
      },
    ],
    info: "Mentale Beschwerden äußern sich z.B. in Antrieblosigkeit, Unruhe, Angstzuständen, Motivationsproblemen, etc.. Körperliche Beschwerden sind mit spürbaren, den Körperstellen zuzuordnenden Schmerzen verbunden.",
  },
  4.1: {
    text: "Haben Sie eher mentale oder körperliche Beschwerden?",
    type: "buttons",
    options: [
      {
        value: "körperlich",
      },
      {
        value: "mental",
      },
      {
        value: "beides",
      },
    ],
    info: "Mentale Beschwerden äußern sich z.B. in Antrieblosigkeit, Unruhe, Angstzuständen, Motivationsproblemen, etc.. Körperliche Beschwerden sind mit spürbaren, den Körperstellen zuzuordnenden Schmerzen verbunden.",
  },
  5: {
    text: "Spüren Sie eine Ausstrahlung in andere Körperbereiche?",
    type: "buttons",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "radiation.png",
      text: {
        all: "Beschwerden können auch an anderen Körperstellen zu Beeinträchtigungen oder Schmerzen führen. So können z.B. Rückenschmerzen auch mit Schmerzen in den Beinen verbunden sein.",
        zahn: "Beschwerden können auch an anderen Körperstellen zu Beeinträchtigungen oder Schmerzen führen. So können z.B. Zahnbeschwerden auch mit Ohrenschmerzen verbunden sein.",
      },
    },
  },
  6: {
    text: "Wohin strahlen sie aus?",
    type: "spreadarea",
    info: {
      image: "backselect.png",
      text: "Klicken Sie auf die Körperstelle, wo Sie den ausstrahlenden Schmerz spüren. Für die Körperrückseite klicken Sie einfach auf „Drehen“.",
    },
  },
  7: {
    text: "Haben Sie eine Bewegungseinschränkung oder ein Taubheitsgefühl?",
    type: "buttons",
    options: [
      {
        value: "Bewegungseinschränkung",
      },
      {
        value: "Taubheitsgefühl",
      },
      {
        value: "Beides",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "limitation.png",
      text: "<p>Eine Bewegungseinschränkung liegt vor, wenn man z.B. das Bein nicht vollständig ausstrecken oder abwinkeln kann.</p><p>Ein Taubheitsgefühl führt dazu, dass es sich an der betroffenen Körperstelle wattig, kribbelig anfühlt oder Sie nichts mehr spüren können.</p>",
    },
  },
  7.1: {
    text: "Haben Sie eine Einschränkung, wie etwa beim Kauen oder Öffnen und Schließen des Mundes? Ist eine Schwellung erkenn-/spürbar?",
    type: "buttons",
    options: [
      {
        value: "Einschränkung",
      },
      {
        value: "Schwellung",
      },
      {
        value: "Beides",
      },
      {
        value: "Nein",
      },
    ],
    info: "Eine Bewegungseinschränkung liegt vor, wenn man z.B. das Kiefer/den Mund nicht gut öffnen oder schließen kann oder beim Kauen Probleme hat.  Ein Taubheitsgefühl führt dazu, dass es sich an der betroffenen Stelle wattig, kribbelig anfühlt oder Sie nichts mehr spüren können.",
  },
  8: {
    text: "Können Sie beschreiben, wie sich Ihre Beschwerden anfühlen?",
    type: "checkbox",
    options: [
      {
        value: "Pochen",
      },
      {
        value: "Stechen",
      },
      {
        value: "Ziehen",
      },
      {
        value: "Klopfen",
      },
      {
        value: "Brennen",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "radiation.png",
      text: "Nicht jeder Schmerz fühlt sich gleich an. Je nach Körperstelle können große Unterschiede im Schmerzempfinden sein. Versuchen Sie Ihren Schmerz zu beschreiben und wählen Sie die zutreffenden Eigenschaften aus.",
    },
  },
  8.1: {
    text: "Können Sie Ihre Schmerzen beschreiben?",
    type: "checkbox",
    options: [
      {
        value: "Pochen",
      },
      {
        value: "Stechen",
      },
      {
        value: "Ziehen",
      },
      {
        value: "Klopfen",
      },
      {
        value: "Brennen",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "radiation.png",
      text: "Nicht jeder Schmerz fühlt sich gleich an. Je nach Körperstelle können große Unterschiede im Schmerzempfinden sein. Versuchen Sie Ihren Schmerz zu beschreiben und wählen Sie die zutreffenden Eigenschaften aus.",
    },
  },
  8.2: {
    text: "Spüren Sie auch eine oder mehrere der folgenden Beschwerden?",
    type: "checkbox",
    options: [
      {
        value: "Kribbeln",
      },
      {
        value: "Krämpfe",
      },
      // {
      //   value: "Bewegungssperre",
      // },
      {
        value: "Zittern",
        hide: "zahn",
      },
      {
        value: "Kraftlosigkeit",
        hide: "zahn",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "radiation.png",
      text: "Nicht jeder Schmerz fühlt sich gleich an. Je nach Körperstelle können große Unterschiede im Schmerzempfinden sein. Versuchen Sie Ihren Schmerz zu beschreiben und wählen Sie die zutreffenden Eigenschaften aus.",
    },
  },
  8.3: {
    text: "Können Sie beschreiben, wie Sie sich fühlen?",
    type: "checkbox",
    options: [
      {
        value: "Niedergeschlagen/schwermütig",
      },
      {
        value: "Müde/antriebslos",
      },
      {
        value: "Unruhig/rastlos",
      },
      {
        value: "Appetitlos/Heißhunger",
      },
      {
        value: "Angst zu Versagen",
      },
      {
        value: "Konzentrationsprobleme",
      },
      {
        value: "Nein",
      },
    ],
  },
  9: {
    text: "Trifft ein oder mehrere der folgenden Probleme auf Sie zu?",
    type: "checkbox",
    showSonstiges: true,
    options: [
      {
        value: "Zahnfleischbluten",
      },
      {
        value: "Mundgeruch",
      },
      // {
      //   value: "Zahnverfärbung (beige)",
      // },
      {
        value: "Zahn verloren",
      },
      {
        value: "Zahn abgebrochen",
      },
      {
        value: "Zahn gelockert",
      },
      {
        value: "Zahnfüllung verloren",
      },
      {
        value: "Druckstellen (durch Prothese, Zahnregulierung, etc.)",
        id: "Druckstellen",
      },
      {
        value: "Probleme mit Zahnersatz",
        id: "Zahnersatz",
      },
      {
        value: "Zahnfehlstellung",
        id: "Zahnfehlstellung",
      },
      {
        value: "Nein",
      },
    ],
  },
  10: {
    text: "Seit wann haben Sie diese Beschwerden?",
    type: "slider",
    options: [
      {
        value: "seit heute",
      },
      {
        value: "seit gestern",
      },
      {
        value: "seit 2 Tagen",
      },
      {
        value: "seit 3 Tagen",
      },
      {
        value: "seit 4 Tagen",
      },
      {
        value: "seit 5 Tagen",
      },
      {
        value: "seit 1 Woche",
      },
      {
        value: "seit 2 Wochen",
      },
      {
        value: "seit 3 Wochen",
      },
      {
        value: "seit 1 Monat",
      },
      {
        value: "seit 2 Monaten",
      },
      {
        value: "seit 3 Monaten",
      },
      {
        value: "seit 6 Monaten",
      },
      {
        value: "seit 9 Monaten",
      },
      {
        value: "seit 1 Jahr",
      },
      {
        value: "seit mehr als 1 Jahr",
      },
    ],
    info: {
      image: "calendar.png",
      text: "Klicken Sie auf den Kreis und schieben Sie den Regler zu dem Zeitpunkt, wo Ihre Beschwerden begonnen haben.",
    },
  },
  11: {
    text: "Wie stark sind Ihre Beschwerden?",
    type: "slider",
    options: [
      {
        value: "leicht",
        image: "s02.svg",
      },
      {
        value: "mäßig",
        image: "s03.svg",
      },
      {
        value: "stark",
        image: "s04.svg",
      },
      {
        value: "sehr stark",
        image: "s05.svg",
      },
    ],
    info: {
      image: "calendar.png",
      text: "Schieben Sie den Regler entlang der Linie und wählen Sie den Smiley aus, der Ihrem Schmerzempfinden entspricht.",
    },
  },
  12: {
    text: "Wie treten die Beschwerden auf?",
    type: "checkbox",
    options: [
      {
        value: "Vereinzelt",
      },
      {
        value: "Anhaltend",
      },
      {
        value: "Wiederkehrend",
      },
      {
        value: "Ruhe",
        hide: "zahn",
      },
      {
        value: "Bewegung",
        hide: "zahn",
      },
    ],
    info: "Schmerzen treten sehr individuell auf. Bitte geben Sie an, in welcher Häufigkeit sie vorhanden sind und ob Sie die Beschwerden in Ruhe oder Bewegung wahrnehmen.",
  },
  12.1: {
    text: "Wie häufig haben Sie die Beschwerden?",
    type: "buttons",
    options: [
      {
        value: "Vereinzelt",
      },
      {
        value: "Anhaltend",
      },
    ],
  },
  12.2: {
    text: "Wie häufig haben Sie die Beschwerden?",
    type: "checkbox",
    options: [
      {
        value: "Vereinzelt",
      },
      {
        value: "Anhaltend",
      },
      {
        value: "Wiederkehrend",
      },
    ],
    info: "Schmerzen treten sehr individuell auf. Bitte geben Sie an, in welcher Häufigkeit sie vorhanden sind. ",
  },
  13: {
    text: "Fühlen Sie den Schmerz eher innerlich oder äußerlich?",
    type: "buttons",
    options: [
      {
        value: "Innerlich",
      },
      {
        value: "Äußerlich",
      },
      {
        value: "Beides",
      },
      {
        value: "Ich weiß nicht",
      },
    ],
    info: {
      image: { all: "inner-outer.png", zahn: "default.png" },
      text: {
        all: "Innerliche Schmerzen sind mit den Fingern schwer zu ertasten. Äußerliche Schmerzen liegen eher auf der Hautoberfläche oder knapp darunter. Die betroffene Stelle kann meistens mit dem Finger ertastet und der Schmerz ausgelöst werden.",
        zahn: "Innerliche Schmerzen betreffen das Innere des Mundes wie Zähne, Kieferinnenseite, Gaumen oder die Zunge. Äußerliche Schmerzen sind von außen ertastbar.",
      },
    },
  },
  14: {
    text: "Gab es einen speziellen Anlassfall oder eine Vorerkrankung?",
    type: "buttons",
    options: [
      {
        value: "Unfall",
      },
      {
        value: "Vorerkrankung",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "paintype.png",
      text: {
        all: "Mit Vorerkrankung ist gemeint, ob Sie eine andere Krankheit haben/hatten, die mit Ihren aktuellen Beschwerden in Zusammenhang stehen könnte. Klicken Sie auf „Unfall“, wenn Ihre Beschwerden dadurch verursacht wurden.",
        zahn: 'Mit Vorerkrankung ist gemeint, ob Sie eine andere Krankheit haben/hatten, die mit Ihren aktuellen Beschwerden in Zusammenhang stehen könnte. So kann sich z.B. eine Chemotherapie auf die Zähne auswirken. Klicken Sie auf "Unfall", wenn Ihre Beschwerden beispielsweise durch einen Sturz verursacht wurden.',
      },
    },
  },
  14.1: {
    text: "Haben Sie eine Vorerkrankung?",
    type: "buttons",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
    info: {
      image: "paintype.png",
      text: "Mit Vorerkrankung ist gemeint, ob Sie eine Krankheit haben/hatten, die mit Ihren aktuellen Beschwerden in Zusammenhang stehen könnte.",
    },
  },
  15: {
    text: "Wissen Sie, welche Krankheit Sie haben?",
    type: "textRadio",
    cancelText: "Nein",
    info: "Diagnosen oder Krankheiten werden vom Arzt bestimmt. Sollte Sie von einem Arzt bereits eine Diagnose oder eine bestimmte Krankheit mitgeteilt bekommen haben, so schreiben Sie diese bitte in das Freitextfeld.",
  },
  15.1: {
    text: "Kennen Sie Ihre Diagnose/Krankheit?",
    type: "textRadio",
    cancelText: "Nein",
    info: "Diagnosen oder Krankheiten werden vom Arzt bestimmt. Sollte Sie von einem Arzt bereits eine Diagnose oder eine bestimmte Krankheit mitgeteilt bekommen haben, so schreiben Sie diese bitte in das Freitextfeld.",
  },
  15.2: {
    text: "Kennen Sie Ihre Diagnose?",
    type: "textRadio",
    cancelText: "Nein",
    // search: "zahnDiagnosen",
    info: "Diagnosen oder Krankheiten werden vom Arzt bestimmt. Sollte Sie von einem Arzt bereits eine Diagnose oder eine bestimmte Krankheit mitgeteilt bekommen haben, so schreiben Sie diese bitte in das Freitextfeld.",
  },
  16: {
    text: "Werden Sie aktuell behandelt?",
    type: "checkbox",
    options: [
      {
        value: "Medikamente",
      },
      {
        value: "Therapie",
      },
      {
        value: "Sonstiges",
      },
      {
        value: "Nein",
      },
    ],
    info: "Bitte geben Sie an ob und in welcher Form Sie die Beschwerden behandeln bzw. wie sie behandelt werden.",
  },
  16.1: {
    text: "Sind Sie bereits in Behandlung?",
    type: "buttons",
    info: "Bitte geben Sie an, ob Sie die Beschwerden aktuell behandeln bzw. behandeln lassen.",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
  },
  16.2: {
    text: "Werden Sie aktuell behandelt?",
    type: "checkbox",
    options: [
      {
        value: "Medikamente",
      },
      {
        value: "Therapie",
      },
      {
        value: "Sonstiges",
      },
      {
        value: "Nein",
      },
    ],
    info: "Bitte geben Sie an ob und in welcher Form Sie die Beschwerden behandeln bzw. wie sie behandelt werden.",
  },
  17: {
    text: "Geht es Ihnen seit Behandlungsbeginn besser?",
    type: "buttons",
    options: [
      { value: "Ja" },
      { value: "Nein" },
      { value: "Ein bisschen besser" },
      { value: "Viel besser" },
      { value: "Schlechter" },
    ],
  },
  17.1: {
    text: "Geht es Ihnen seit Behandlungsbeginn besser?",
    type: "buttons",
    options: [
      { value: "Ja" },
      { value: "Nein" },
      { value: "Ein bisschen besser" },
      { value: "Viel besser" },
      { value: "Schlechter" },
    ],
  },
  18: {
    text: "Haben Sie auch Interesse ein Coaching zur Verbesserung Ihrer Lebensqualität zu erhalten?",
    type: "buttons",
    info: "Das Gesundheits-Coaching von MedicalContact hilft Menschen mit Herzerkrankungen, Diabetes Typ II oder Stress. Lassen Sie sich von einem persönlichen Coach zeigen, wie Sie Ihre Lebensqualität verbessern können.",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
  },
  19: {
    text: "Haben Sie bereits einen Behandlungsplan erhalten?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
    info: {
      text: "Mit einem alternativen Angebot erhalten Sie ein gutes Gefühl zur Höhe der Kosten.",
      // 'Ihren Heil- und Kostenplan können Sie über die <a href="https://www.arag.de/service/kundenservice/gesundheitsapp/" target="_blank">ARAG Gesundheitsapp</a> zur Vorabprüfung einreichen.',
    },
  },
  19.1: {
    text: "Möchten Sie Ihren Behandlungsplan prüfen lassen?",
    type: "upload",
    info: "Ihren Behandlungsplan können Sie als Dokument aus einem Ordner hochladen oder machen Sie einfach ein Foto davon.",
    errorMessage:
      "Bitte laden Sie Ihren Behandlungsplan hoch, damit wir Sie unterstützen können.",
  },
  19.2: {
    text: "Haben Sie bereits einen Behandlungsplan erhalten?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
    info: {
      text: "Mit einem alternativen Angebot erhalten Sie ein gutes Gefühl zur Höhe der Kosten.",
      // 'Ihren Heil- und Kostenplan können Sie über die <a href="https://www.arag.de/service/kundenservice/gesundheitsapp/" target="_blank">ARAG Gesundheitsapp</a> zur Vorabprüfung einreichen.',
    },
  },
  20: {
    text: "Wie möchten Sie eine erste Abklärung machen?",
    type: "buttons",
    options: [
      {
        value: "Persönlich mit einem Arzt vor Ort",
        id: "A",
      },
      // {
      //   value: "Video-Arztgespräch",
      //   id: "B",
      // },
      {
        value: "Mit Hilfe von ARAG Gesundheitsassistenten",
        id: "C",
      },
    ],
    // info: {
    //   image: "happy.png",
    //   text:
    //     "<p>Für eine <b>persönliche Behandlung</b> vor Ort werden die Experten von <b>BetterDoc</b> bzw. <b>der Zahnärztlichen Tageskliniken (ZTK)</b> den passenden Spezialisten für Sie finden.</p><p>Wählen Sie für ein erstes Gespräch eine <b>Videoabklärung</b>, so wird unser Partner <b>MedGate</b> Sie mit einem auf Ihre Beschwerden spezialisierten Arzt verbinden.</p>",
    // },
  },
  20.1: {
    text: "Wie möchten Sie eine erste Abklärung machen?",
    type: "buttons",
    options: [
      {
        value: "Persönlich mit einem Arzt vor Ort",
        id: "A",
      },
      {
        value: "Video-Arztgespräch",
        id: "B",
      },
    ],
    // info: {
    //   image: "happy.png",
    //   text:
    //     "<p>Für eine <b>persönliche Behandlung</b> vor Ort werden die Experten von <b>BetterDoc</b> bzw. <b>der Zahnärztlichen Tageskliniken (ZTK)</b> den passenden Spezialisten für Sie finden.</p><p>Wählen Sie für ein erstes Gespräch eine <b>Videoabklärung</b>, so wird unser Partner <b>MedGate</b> Sie mit einem auf Ihre Beschwerden spezialisierten Arzt verbinden.</p>",
    // },
  },
  23: {
    type: "explanation",
    summary: {
      text: "Gewählter Partner",
    },
  },
  24: {
    text: "Gibt es Zeitfenster, an denen Sie nicht können?",
    type: "buttons",
    options: [
      {
        value: "Ja",
      },
      {
        value: "Nein",
      },
    ],
  },
  25: {
    text: {
      all: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Arztsuche und Terminvereinbarung berücksichtigen können.",
      zahn: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Terminvereinbarung berücksichtigen können.",
    },
    type: "dayTimeSelection",
  },
  25.1: {
    text: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Arztsuche und Terminvereinbarung berücksichtigen können.",
    type: "dateTimeInterval",
  },
  25.2: {
    text: {
      all: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Arztsuche und Terminvereinbarung berücksichtigen können.",
      zahn: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Terminvereinbarung berücksichtigen können.",
    },
    type: "dayTimeInterval",
  },
  26: {
    text: "Nehmen Sie aktuell Medikamente?",
    type: "checkbox",
    options: [
      {
        value: "Schmerzmittel",
      },
      {
        value: "Antibiotika",
      },
      {
        value: "Heilsalbe",
      },
      {
        value: "Mundspülungen",
      },
      {
        value: "Sonstiges",
      },
      {
        value: "Nein",
      },
    ],
    info: "Das können sowohl beschwerdelindernde/-verbessernde Arzneimittel oder auch alternative Medizin sein.",
  },
  27: {
    text: "Haben Sie bereits eine Kostenzusage der ARAG erhalten?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
  },
  27.1: {
    text: "Bitte laden Sie Ihren Behandlungsplan hoch.",
    description:
      "Das Dokument wird auch in Ihrem Roodie.Safe für Sie abgelegt.",
    type: "upload",
    info: "Ihren Behandlungsplan können Sie als Dokument aus einem Ordner hochladen oder machen Sie einfach ein Foto davon.",
    errorMessage:
      "Bitte laden Sie Ihren Behandlungsplan hoch, damit wir Sie unterstützen können.",
  },
  28: {
    text: "Sind Sie auch auf der Suche nach einem Zahnarzt für die Behandlung?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
  },
  96: {
    text: "Sie haben die Wahl. Möchten Sie gleich online einen Termin vereinbaren oder telefonisch den Termin vereinbaren?",
    type: "buttons",
    options: [
      {
        value: "Online Termin buchen",
        icon: "call",
      },
      {
        value: "Telefonische Kontaktaufnahme",
        icon: "calendar",
      },
    ],
  },
  97: {
    type: "contact",
    summary: {
      text: "Persönliche Daten",
    },
  },
  98: {
    text: "Geben Sie doch bitte Ihre bevorzugten Zeitfenster an, damit wir dies bei der Terminvereinbarung berücksichtigen können.",
    type: "dayTimeSelection",
  },
  99: {
    type: "privacy",
    summary: {
      text: "Datenschutzbestimmungen",
    },
  },
  100: {
    type: "answerSummary",
    text: "Roodie.Check Zusammenfassung",
  },
};
